<template>
  <div>
    <van-tabs style="width: 100%;padding-top: 88px" color="#1875f8" line-width="15px" line-height="3px"
              title-active-color="#1875f8"
              offset-top="88px" duration="0.5" v-model="active" animated sticky swipeable v-if="infoNRes.data">
      <van-tab v-for="(data,index) in infoNRes.data" :title="data.name" :title-style="'font-size:15px;'+(active===index?'font-weight:border':'')">
        <lazy-component>
          <div class="bodyBox">

            <div v-for="(dataSon,indexSon) in infoNRes.data" v-if="active === index && index === indexSon"
                 :key="indexSon">

              <van-pull-refresh v-model="refreshing[index]" @refresh="onRefresh(index)">
                <van-list v-model="loading[index]" :finished="finished[index]" finished-text="没有更多了"
                          @load="onLoad(index)">

                  <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" v-if="active === 0"
                             @change="onChange">
                    <van-swipe-item v-for="(item,indexSwipe) in adRes.data">
                      <img :src="item.images" class="img" @click="goAd(indexSwipe)">
                    </van-swipe-item>


                    <template #indicator>
                      <div class="custom-indicator">
                        <div v-for="(itemS,indexSwipeS) in adRes.data"
                             :class="indexSwipeS === current?'indicatorOn':'indicator'"></div>

                      </div>
                    </template>
                  </van-swipe>

                  <div v-for="(value,indexSS) in list[index]" :key="indexSS" style="width: 100%">
                    <div class="infoBox" @click="$infoDetailJump(value.id)">


                      <div class="boxLeft">
                        <div class="leftIn">

                          <div class="infoTitle"><span class="infoTitleText">{{ value.title.slice(0, 30) }}</span></div>
                          <div class="summary"><span class="summaryText">{{ $summary(value.summary) }}</span></div>
                          <div class="infoBottom">
                            <div class="symbolTypeBox">
                              <div class="symbolTypeBoxIn"></div>
                              <div class="symbolType">{{ value.symbol_type_name }}</div>
                            </div>
                            <span class="author">{{ value.author_CN }}</span>
                            <span class="dateShowInfo">{{ $dateChange(value.release_time_check) }}</span>
                          </div>

                        </div>
                      </div>
                      <div class="boxRight">

                        <div class="rightIn">

                          <img :src="value.cover" style="height: 100%;width: 100%;border-radius: 4px;">

                        </div>

                      </div>


                    </div>
                    <div class="line"></div>


                  </div>

                </van-list>
              </van-pull-refresh>

            </div>


          </div>
        </lazy-component>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>

export default {
  name: "information",
  data() {
    return {
      active: 0,
      current: 0,
      list: [],
      loading: [],
      finished: [],
      refreshing: [],
      infoNQuery: {},
      infoQuery: [],
      infoNRes: {},
      infoRes: [],
      infoQueryEn: {},
      adInfo: {evkey: 'app_information_top'},
      adRes: {data: {}}

    }
  },
  methods: {
    onChange(index) {
      this.current = index;
    },
    onLoad(index) {
      if (this.refreshing[index]) {
        this.infoRes[index] = {data: {list: []}}
        this.refreshing[index] = false;
      }

      this.infoQueryEn[index] = this.$encrypt(this.$genQuery(this.infoQuery[index]))
      this.$get(this.$store.state.apiUrl + "/information/article", {qdata: this.infoQueryEn[index]}).then(res => {
        this.infoRes[index] = res;
        for (let i = 0; i < this.infoRes[index].data.list.length; i++) {
          this.list[index].push(this.infoRes[index].data.list[i]);
        }
        this.$forceUpdate();
        this.loading[index] = false;
        this.infoQuery[index].last_id = this.infoRes[index].data.list[this.infoRes[index].data.list.length - 1].id;

        if (this.infoRes[index].data.list.length % 10 !== 0) {
          this.finished[index] = true;
        }

      }).catch(err => {
        console.log(err)
      })

    },
    onRefresh(index) {
      // 清空列表数据
      this.finished[index] = false;
      this.list[index] = [];
      this.infoQuery[index].last_id = 0;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading[index] = true;
      this.onLoad(index);
    },


    getArticleNav() {
      this.infoNQuery = this.$encrypt(this.$genQuery(this.infoNQuery))
      this.$get(this.$store.state.apiUrl + "/information/articleNav", {qdata: this.infoNQuery}).then(res => {
        this.infoNRes = res
        for (let i = 0; i < this.infoNRes.data.length; i++) {
          this.list[i] = [];
          this.loading[i] = false;
          this.finished[i] = false;
          this.refreshing[i] = false;
          this.infoRes[i] = {data: {list: []}};
          this.infoQuery[i] = {
            type: this.infoNRes.data[i].type,
            page_size: 10,
            type_id: this.infoNRes.data[i].type_id,
            last_id: 0
          }

        }
      }).catch(err => {
        console.log(err)
      })
    },

    getAd() {
      this.adInfo = this.$encrypt(this.$genQuery(this.adInfo))
      this.$post(this.$store.state.apiUrl + "/ads/getad", {qdata: this.adInfo}).then(res => {
        this.adRes = res
      }).catch(err => {
        console.log(err)
      })

    },

    goAd(index) {
      let urlSplit = this.adRes.data[index].jumpinfo.split("=")
      let title = this.adRes.data[index].title
      let url = urlSplit[1]
      if (url) {
        this.$router.push({path: '/advertisement', query: {url, title}})
      }
    }
  },


  created() {
    this.getArticleNav()
    this.getAd()
  }


}
</script>

<style scoped>
.bodyBox {
  width: 100%;
  background-color: #f4f6fa;
  /*padding-top: 88px;*/

}

.my-swipe .van-swipe-item {
  background-color: white;
  /*padding-top: 4px;*/
}

.img {
  width: 100%;
  border-radius: 8px;
  padding:  4px 4px;
  box-sizing: border-box;
}

.custom-indicator {
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

}

.indicatorOn {
  width: 10px;
  height: 2px;
  margin: 0 5px;
  background: rgba(0, 102, 204, 0.7);
}

.indicator {
  width: 10px;
  height: 2px;
  margin: 0 5px;
  background: rgba(196, 215, 233, 0.7);
}


.line {
  width: 100%;
  height: 1px;
  background-color: #e9e9e9;
}

</style>
